import React from 'react';
import PropTypes from 'prop-types';

import User from './user';

export class Users extends React.Component {
  static propTypes = {
    controlIcon: PropTypes.object.isRequired,
    emptyMessage: PropTypes.string,
    users: PropTypes.array.isRequired,

    onSelect: PropTypes.func.isRequired
  }

  render() {
    if (this.props.users.length === 0) {
      return (
        <h6 className="mt-3 text-center text-muted">
          {this.props.emptyMessage}
        </h6>
      );
    }

    return (
      <div className="d-flex flex-column px-3">
        {this.props.users.map((user, i) => (
          <User
            controlIcon={this.props.controlIcon}
            index={i}
            key={user.id}
            user={user}
            onSelect={this.props.onSelect}
          />
        ))}
      </div>
    );
  }
}

export default Users;
